import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useShippingRates, ShippingRatesProvider } from '../../../mapi/ShippingRatesProvider';
import { cashbotName, FormatMessage } from '../../core';
import { ShippingMethodSelect } from '../fields';
import { AddressListing } from '../../address/AddressListing';
import { shippingMessages } from './lineItemMessages';
import { addOrUpdateShippingGroup } from '../../../shipping/shippingModule';
import { shippingMethodsSort } from '../fields/ShippingMethodField';

export const LineItemShippingRatesProvider = ({ lineItem, children }) => {
    const addressWithMAPIFields = {
        ...lineItem.shippingGroup.toAddress,
        countryCode: 'US',
        street: lineItem.shippingGroup.toAddress.street1 ? lineItem.shippingGroup.toAddress.street1 : ''
    };
    return (
        <ShippingRatesProvider initialAddress={addressWithMAPIFields} initialQuantity={lineItem.quantity}>
            {children}
        </ShippingRatesProvider>
    );
};
LineItemShippingRatesProvider.propTypes = {
    lineItem: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
};

export const InnerLineItemShipping = ({ lineItem, doAddOrUpdateShippingGroup }) => {
    const addressWithMAPIFields = {
        ...lineItem.shippingGroup.toAddress,
        countryCode: 'US',
        street: lineItem.shippingGroup.toAddress.street1 ? lineItem.shippingGroup.toAddress.street1 : ''
    };
    const shippingToken = lineItem.shippingGroup.shippingMethodToken;

    const { shippingMethods, isLoading, error, doFetch, numFetches, fetchShippingMethods } = useShippingRates();

    const doSave = (shippingMethodToken, shippingMethod) => {
        doAddOrUpdateShippingGroup({ ...lineItem.shippingGroup, shippingMethodToken, shippingMethod });
    };

    if (shippingMethods.length > 0) {
        shippingMethods.sort((shipMethodA, shipMethodB) => shippingMethodsSort(shipMethodA, shipMethodB));
    }

    const shippingMethodsSelectorProps = {
        name: `shippingGroup.shippingMethodToken`,
        cashbotName,
        shippingMethods,
        isLoading,
        error,
        numFetches,
        linkProps: {
            cashbotName,
            type: 'button',
            id: lineItem.id,
            onClick: () => fetchShippingMethods(),
            isCentered: false,
            linkMessage: { ...shippingMessages.retryFetchShippingMethodsLabel }
        }
    };

    useEffect(() => {
        doFetch(addressWithMAPIFields, lineItem.quantity);
    }, [lineItem.quantity]);

    useEffect(() => {
        if (shippingMethods.length > 0) {
            
            const shippingMethodMap = shippingMethods.reduce((map, obj) => {
                map[obj.token] = {
                    shippingAmount: parseFloat(obj.cost),
                    shippingMethodDisplayName: obj.displayName
                };
                return map;
            }, {});

            
            const tokenToUse = shippingToken === '' ? shippingMethods[0].token : shippingToken;
            doSave(tokenToUse, shippingMethodMap[tokenToUse]);
        }
    }, [shippingMethods, lineItem.shippingGroup.shippingMethodToken]);

    return (
        <Fragment>
            <FormatMessage
                intlMessage={shippingMessages.shipTo}
                className="line-item-ship-to block-text"
                values={{ quantity: lineItem.quantity }}
            />
            <div className="address-block block-text">
                <AddressListing {...lineItem.shippingGroup.toAddress} />
            </div>
            <div className="line-item-shipping-method">
                <ShippingMethodSelect {...shippingMethodsSelectorProps} />
            </div>
        </Fragment>
    );
};

InnerLineItemShipping.propTypes = {
    doAddOrUpdateShippingGroup: PropTypes.func.isRequired,
    lineItem: PropTypes.object.isRequired
};

export const ProvidedLineItemShipping = props => (
    <LineItemShippingRatesProvider lineItem={props.lineItem}>
        <InnerLineItemShipping {...props} />
    </LineItemShippingRatesProvider>
);
ProvidedLineItemShipping.propTypes = {
    lineItem: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => ({
    doAddOrUpdateShippingGroup: shippingGroup => dispatch(addOrUpdateShippingGroup(shippingGroup))
});

export const LineItemShipping = connect(null, mapDispatchToProps)(ProvidedLineItemShipping);
